import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { presentationArtifact } from '../../lib/artifacts/presentation/client';
import { sheetArtifact } from '../../lib/artifacts/sheet/client';
import { textArtifact } from '../../lib/artifacts/text/client';
export const DynamicEditor = ({ artifact: { kind, content: value, title }, onChange })=>{
    // Direct selection based on artifact kind
    let editor;
    switch(kind){
        case 'text':
            // Text-based artifacts use the text artifact editor
            editor = /*#__PURE__*/ _jsx(textArtifact.Editor, {
                value: value,
                onChange: onChange
            });
            break;
        case 'sheet':
            // Spreadsheet artifacts use the sheet artifact editor
            editor = /*#__PURE__*/ _jsx(sheetArtifact.Editor, {
                value: value,
                onChange: onChange
            });
            break;
        case 'presentation':
        case 'powerpoint':
            // Presentation artifacts use the reveal.js presentation editor
            editor = /*#__PURE__*/ _jsx(presentationArtifact.Editor, {
                value: value,
                onChange: onChange
            });
            break;
        case 'image':
            // Images are displayed as-is
            editor = /*#__PURE__*/ _jsx("div", {
                className: "flex items-center justify-center h-full",
                children: /*#__PURE__*/ _jsx("img", {
                    src: value,
                    alt: title,
                    className: "max-w-full max-h-full object-contain"
                })
            });
            break;
        default:
            editor = /*#__PURE__*/ _jsxs("div", {
                className: "text-red-600 p-4 bg-red-50 dark:bg-red-950 rounded",
                children: [
                    "Unsupported artifact type: ",
                    kind,
                    /*#__PURE__*/ _jsx("div", {
                        children: value
                    })
                ]
            });
    }
    return editor;
};
